var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.0002 53.8368L91.6797 49.1573C98.3584 42.4737 101.7 39.127 101.7 34.9816C101.7 30.8362 98.3584 27.4895 91.6797 20.8108L84.5894 13.7205C77.9107 7.04175 74.5689 3.69995 70.4186 3.69995C66.2634 3.69995 62.9216 7.04175 56.2429 13.7205L13.7207 56.2427C7.042 62.9263 3.7002 66.2632 3.7002 70.4184C3.7002 74.5736 7.042 77.9104 13.7207 84.5891L20.811 91.6795C27.4897 98.3582 30.8315 101.7 34.9818 101.7C39.1321 101.7 42.4788 98.3582 49.1575 91.6795L73.437 67.4M35.3738 35.3736L42.3122 42.312M56.1645 14.5878L63.0931 21.5164M14.588 56.1643L21.5166 63.0929M24.9809 45.7714L35.3787 56.1643M45.7716 24.9807L56.1645 35.3736",
    stroke: "black",
    strokeWidth: 7.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSize);
export default __webpack_public_path__ + "static/media/Size.eb8e9ab120f2a9587d1b987fb0a7e67c.svg";
export { ForwardRef as ReactComponent };